var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticStyle:{"border-radius":"10px"},attrs:{"maxlength":6,"outlined":"","hide-details":""},on:{"input":_vm.checkValue},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }